<template>
    <div class="packages-list-body">
        <div class="packages-list-logo">
            <img :src="logo" />
        </div>
        <div class="packages-list-title">
            <div class="packages-list-title-image">
                <img :src="packagesListTitle[0]" />
            </div>
            <div class="packages-list-title-text">
                モバイルアプリ料金体系
            </div>
        </div>
        <div class="packages-list">
            <div class="packages">
                <div class="packages-inset">
                    <div class="packages-title">
                        <img :src="codeList[0][0]" />プラン
                    </div>
                    <div class="ch-msg">
                        <div class="ch-info">
                            <div>
                                <p>地上波</p>
                                <p>15局</p>
                            </div>
                            <div>
                                <p>BS</p>
                                <p>7局</p>
                            </div>
                        </div>
                        <div class="ch-total">
                            <div class="ch-num">22</div>
                            <div class="ch-num-text">
                                <p>合計</p>
                                <p>ch</p>
                            </div>
                        </div>
                    </div>
                    <div class="packages-btn" @click="openCloseOutlined()">
                        受信チャンネル一覧
                    </div>
                    <div class="packages-price-area">
                        <div class="packages-price-inset">
                            <div class="packages-time">
                                3ヶ月
                            </div>
                            <div class="packages-price">
                                59.9<label>USD</label>
                            </div>
                            <!-- <div class="packages-old-price">
                                定価 $59.9
                            </div>
                            <div class="packages-off">
                                OFF率 0%
                            </div> -->
                        </div>
                        <div class="packages-price-inset">
                            <div class="packages-time">
                                12ヶ月
                            </div>
                            <div class="packages-price">
                                199.9<label>USD</label>
                            </div>
                            <!-- <div class="packages-old-price">
                                定価 $199.9
                            </div>
                            <div class="packages-off">
                                OFF率 0%
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="packages">
                <div class="packages-inset">
                    <div class="packages-title">
                        <img :src="codeList[0][1]" />プラン
                    </div>
                    <div class="ch-msg">
                        <div class="ch-info">
                            <div>
                                <p>地上波</p>
                                <p>15局</p>
                            </div>
                            <div>
                                <p>BS</p>
                                <p>20局</p>
                            </div>
                            <div>
                                <p>CS</p>
                                <p>13局</p>
                            </div>
                        </div>
                        <div class="ch-total">
                            <div class="ch-num">48</div>
                            <div class="ch-num-text">
                                <p>合計</p>
                                <p>ch</p>
                            </div>
                        </div>
                    </div>
                    <div class="packages-btn" @click="openCloseOutlined('B')">
                        受信チャンネル一覧
                    </div>
                    <div class="packages-price-area">
                        <div class="packages-price-inset">
                            <div class="packages-time">
                                3ヶ月
                            </div>
                            <div class="packages-price">
                                79.9<label>USD</label>
                            </div>
                            <!-- <div class="packages-old-price">
                                定価 $89.9
                            </div>
                            <div class="packages-off">
                                OFF率 30%
                            </div> -->
                        </div>
                        <div class="packages-price-inset">
                            <div class="packages-time">
                                12ヶ月
                            </div>
                            <div class="packages-price">
                                259.9<label>USD</label>
                            </div>
                            <!-- <div class="packages-old-price">
                                定価 $299.9
                            </div>
                            <div class="packages-off">
                                OFF率 30%
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="packages-list-title">
            <div class="packages-list-title-image">
                <img :src="packagesListTitle[1]" />
            </div>
            <div class="packages-list-title-text">
                テレビアプリ料金体系
            </div>
        </div>
        <div class="packages-list">
            <div class="packages">
                <div class="packages-inset">
                    <div class="packages-title">
                        <img :src="codeList[1][0]" />プラン
                    </div>
                    <div class="ch-msg">
                        <div class="ch-info">
                            <div>
                                <p>地上波</p>
                                <p>15局</p>
                            </div>
                            <div>
                                <p>BS</p>
                                <p>7局</p>
                            </div>
                        </div>
                        <div class="ch-total">
                            <div class="ch-num">22</div>
                            <div class="ch-num-text">
                                <p>合計</p>
                                <p>ch</p>
                            </div>
                        </div>
                    </div>
                    <div class="packages-btn" @click="openCloseOutlined()">
                        受信チャンネル一覧
                    </div>
                    <div class="packages-price-area">
                        <div class="packages-price-inset">
                            <div class="packages-time">
                                3ヶ月
                            </div>
                            <div class="packages-price">
                                89.9<label>USD</label>
                            </div>
                            <!-- <div class="packages-old-price">
                                定価 $89.9
                            </div>
                            <div class="packages-off">
                                OFF率 20%
                            </div> -->
                        </div>
                        <div class="packages-price-inset">
                            <div class="packages-time">
                                12ヶ月
                            </div>
                            <div class="packages-price">
                                299.9<label>USD</label>
                            </div>
                            <!-- <div class="packages-old-price">
                                定価 $299.9
                            </div>
                            <div class="packages-off">
                                OFF率 20%
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="packages">
                <div class="packages-inset">
                    <div class="packages-title">
                        <img :src="codeList[1][1]" />プラン
                    </div>
                    <div class="ch-msg">
                        <div class="ch-info">
                            <div>
                                <p>地上波</p>
                                <p>15局</p>
                            </div>
                            <div>
                                <p>BS</p>
                                <p>20局</p>
                            </div>
                            <div>
                                <p>CS</p>
                                <p>13局</p>
                            </div>
                        </div>
                        <div class="ch-total">
                            <div class="ch-num">48</div>
                            <div class="ch-num-text">
                                <p>合計</p>
                                <p>ch</p>
                            </div>
                        </div>
                    </div>
                    <div class="packages-btn" @click="openCloseOutlined('B')">
                        受信チャンネル一覧
                    </div>
                    <div class="packages-price-area">
                        <div class="packages-price-inset">
                            <div class="packages-time">
                                3ヶ月
                            </div>
                            <div class="packages-price">
                                149.9<label>USD</label>
                            </div>
                            <!-- <div class="packages-old-price">
                                定価 $149.9
                            </div>
                            <div class="packages-off">
                                OFF率 30%
                            </div> -->
                        </div>
                        <div class="packages-price-inset">
                            <div class="packages-time">
                                12ヶ月
                            </div>
                            <div class="packages-price">
                                499.9<label>USD</label>
                            </div>
                            <!-- <div class="packages-old-price">
                                定価 $499.9
                            </div>
                            <div class="packages-off">
                                OFF率 30%
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="packages-list-title">
            <div class="packages-list-title-image block">
                <img :src="packagesListTitle[2]" />
            </div>
            <div class="packages-list-title-text">
                モバイルアプリ <img :src="add" class="add" /> テレビアプリ
            </div>
        </div>
        <div class="packages-list">
            <div class="packages">
                <div class="packages-inset">
                    <div class="packages-title">
                        <img :src="codeList[2][0]" />プラン
                    </div>
                    <div class="ch-msg">
                        <div class="ch-info">
                            <div>
                                <p>地上波</p>
                                <p>15局</p>
                            </div>
                            <div>
                                <p>BS</p>
                                <p>7局</p>
                            </div>
                        </div>
                        <div class="ch-total">
                            <div class="ch-num">22</div>
                            <div class="ch-num-text">
                                <p>合計</p>
                                <p>ch</p>
                            </div>
                        </div>
                    </div>
                    <div class="packages-btn" @click="openCloseOutlined()">
                        受信チャンネル一覧
                    </div>
                    <div class="packages-price-area">
                        <div class="packages-price-inset">
                            <div class="packages-time">
                                3ヶ月
                            </div>
                            <div class="packages-price">
                                89.9<label>USD</label>
                            </div>
                            <div class="packages-old-price">
                                定価 $149.9
                            </div>
                            <div class="packages-off">
                                OFF率 20%
                            </div>
                        </div>
                        <div class="packages-price-inset">
                            <div class="packages-time">
                                12ヶ月
                            </div>
                            <div class="packages-price">
                                299.9<label>USD</label>
                            </div>
                            <div class="packages-old-price">
                                定価 $499.9
                            </div>
                            <div class="packages-off">
                                OFF率 20%
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="packages">
                <div class="packages-inset">
                    <div class="packages-title">
                        <img :src="codeList[2][1]" />プラン
                    </div>
                    <div class="ch-msg">
                        <div class="ch-info">
                            <div>
                                <p>地上波</p>
                                <p>15局</p>
                            </div>
                            <div>
                                <p>BS</p>
                                <p>20局</p>
                            </div>
                            <div>
                                <p>CS</p>
                                <p>13局</p>
                            </div>
                        </div>
                        <div class="ch-total">
                            <div class="ch-num">48</div>
                            <div class="ch-num-text">
                                <p>合計</p>
                                <p>ch</p>
                            </div>
                        </div>
                    </div>
                    <div class="packages-btn" @click="openCloseOutlined('B')">
                        受信チャンネル一覧
                    </div>
                    <div class="packages-price-area">
                        <div class="packages-price-inset">
                            <div class="packages-time">
                                3ヶ月
                            </div>
                            <div class="packages-price">
                                119.9<label>USD</label>
                            </div>
                            <div class="packages-old-price">
                                定価 $239.9
                            </div>
                            <div class="packages-off">
                                OFF率 30%
                            </div>
                        </div>
                        <div class="packages-price-inset">
                            <div class="packages-time">
                                12ヶ月
                            </div>
                            <div class="packages-price">
                                399.9<label>USD</label>
                            </div>
                            <div class="packages-old-price">
                                定価 $639.9
                            </div>
                            <div class="packages-off">
                                OFF率 30%
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tips-list">
                <div class="tips">
                    スマホアプリとテレビアプリは同一サービスではありませんので、同じIDの共通利用はできません。
                </div>
                <div class="tips">スマホアプリのIDは、複数デバイスでの同時利用ができません。</div>

            </div>
        </div> -->
        <packages-channel ref="packagesChannel"></packages-channel>
    </div>
</template>
<script>
import packagesChannel from './packages-channel'
import { packagesListTitle, logo, add, codeList } from '../../../images/packages-list'
export default {
    components: {
        packagesChannel
    },
    data () {
        return {
            packagesListTitle,
            logo,
            add,
            codeList
        }
    },
    methods: {
        openCloseOutlined (className = "A") {
            this.$refs.packagesChannel.init(className)
        }
    }
}
</script>
<style scoped>
.packages-list-body {
    width: 100%;
    box-sizing: border-box;
    padding-top: 60px;
    background: #f3f3f3;
    padding-bottom: 30px;
}
.packages-list-logo img {
    display: block;
    margin: 0 auto;
    height: 47px;
}
.packages-list-title-image img {
    display: inline-block;
    height: 26px;
}
.packages-list-title-image {
    display: inline-block;
    margin-top: 5px;
    vertical-align: top;
    margin-right: 10px;
}
.packages-list-title-image.block {
    display: block;
    margin-top: 0;
    margin-bottom: 15px;
}
.packages-list-title-image.block img {
    height: 28px;
}
.packages-list-title-text {
    display: inline-block;
    font-size: 24px;
    font-family: A-OTF Gothic MB101 Pr5;
    font-weight: bold;
    color: #000000;
    line-height: 40px;
    vertical-align: top;
}
.packages-list-title {
    text-align: center;
    margin-top: 25px;
    margin-bottom: 30px;
}
.packages-list {
    width: 100%;
    box-sizing: border-box;
    padding: 5px;
}
.packages {
    width: 50%;
    display: inline-block;
    box-sizing: border-box;
    padding: 5px;
    vertical-align: top;
}
.add {
    display: inline-block;
    height: 20px;
}
.packages-list .packages-inset {
    background: #fff;
    border-radius: 5px;
    padding-bottom: 5px;
    /* height: 225px; */
    height: 190px;
}
.packages-title img{
    display: inline-block;
    margin-left: 10px;
    margin-right: 10px;
    height: 55px;
    vertical-align: top;
    margin-top: -22.5px;
}
.packages-title {
    font-size: 20px;
    font-family: A-OTF Gothic MB101 Pr5;
    font-weight: normal;
    color: #FFFFFF;
    line-height: 34px;
    height: 34px;
    border-radius: 5px 5px 0 0;
}
.packages-list-body .packages-list:nth-child(3) .packages-title {
    background-color: #FDB819;
}
.packages-list-body .packages-list:nth-child(5) .packages-title {
    background-color: #20BBF5;
}
.packages-list-body .packages-list:nth-child(7) .packages-title {
    background-color: #F647A7;
}
.ch-msg {
    display: flex;
    box-sizing: border-box;
    padding: 10px;
    height: 63px;
}
.ch-info,.ch-total {
    flex: 1;
}
.ch-info {
    margin-right: 10px;
}
.ch-info div {
    display: flex;
    justify-content: space-between;
    font-size: 10px;
    font-family: A-OTF Gothic MB101 Pr5;
    font-weight: normal;
    color: #000000;
    line-height: 28px;
}
.ch-msg p{
    margin: 0;
    line-height: 15px;
}
.ch-num {
    font-size: 30px;
    font-family: ITC Avant Garde Gothic Std;
    font-weight: bold;
    color: #20BBF5;
}
.ch-total {
    line-height: 30px;
    display: flex;
}
.ch-num-text p:nth-child(1) {
    color: #888;
    font-size: 10px;
}
.ch-num-text p:nth-child(2) {
    color: #20BBF5;
    font-weight: bold;
}
.packages-btn {
    height: 25px;
    width:80%;
    margin: 0 auto;
    text-align: center;
    color: #fff;
    font-size: 12px;
    line-height: 25px;
    background: #20BBF5;
    border-radius: 25px;
    margin-bottom: 5px;
    border:none;
    outline: none;
}
.packages-price-area {
    display: flex;
}
.packages-price-inset {
    flex: 1;
    box-sizing: border-box;
    padding: 0 5px;
    text-align: center;
}
.packages-price-area .packages-price-inset:nth-child(1) {
    border-right: #20BBF5 1px dashed;
}
.packages-time {
    font-size: 12.5px;
    font-family: A-OTF Gothic MB101 Pr5;
    font-weight: bold;
    color: #000000;
}
.packages-price {
    font-size: 20px;
    font-family: ITC Avant Garde Gothic Std;
    font-weight: bold;
    color: #20BBF5;
}
.packages-price label {
    font-size: 10px;
}
.packages-old-price {
    font-size: 12px;
    font-weight: normal;
    color: #000;
}
.packages-off {
    font-size: 8px;
    font-family: A-OTF Gothic MB101 Pr5;
    font-weight: normal;
    color: #20BBF5;
}
.packages-old-price, .packages-off {
    transform: scale(0.9,0.9);
}
.packages-list-body .packages-list:nth-child(3) .packages-price {
    color: #FDB819;
}
.packages-list-body .packages-list:nth-child(5) .packages-price {
    color: #20BBF5;
}
.packages-list-body .packages-list:nth-child(7) .packages-price {
    color: #F647A7;
}
.packages-list-body .packages-list:nth-child(3) .packages-off {
    color: #FDB819;
}
.packages-list-body .packages-list:nth-child(5) .packages-off {
    color: #20BBF5;
}
.packages-list-body .packages-list:nth-child(7) .packages-off {
    color: #F647A7;
}
.packages-list-body .packages-list:nth-child(3) .ch-num {
    color: #FDB819;
}
.packages-list-body .packages-list:nth-child(5) .ch-num {
    color: #20BBF5;
}
.packages-list-body .packages-list:nth-child(7) .ch-num {
    color: #F647A7;
}
.packages-list-body .packages-list:nth-child(3) .ch-num-text p:nth-child(2) {
    color: #FDB819;
}
.packages-list-body .packages-list:nth-child(5) .ch-num-text p:nth-child(2) {
    color: #20BBF5;
}
.packages-list-body .packages-list:nth-child(7) .ch-num-text p:nth-child(2) {
    color: #F647A7;
}
.packages-list-body .packages-list:nth-child(3) .packages-btn {
    background-color: #FDB819;
}
.packages-list-body .packages-list:nth-child(5) .packages-btn {
    background-color: #20BBF5;
}
.packages-list-body .packages-list:nth-child(7) .packages-btn {
    background-color: #F647A7;
}
.packages-list-body .packages-list:nth-child(3) .packages-btn:active {
    background-color: #FDDA19;
}
.packages-list-body .packages-list:nth-child(5) .packages-btn:active {
    background-color: #2093F5;
}
.packages-list-body .packages-list:nth-child(7) .packages-btn:active {
    background-color: #FB2F81;
}
.packages-list-body .packages-list:nth-child(3) .packages-price-inset {
    border-color: #FDB819;
}
.packages-list-body .packages-list:nth-child(5) .packages-price-inset {
    border-color: #20BBF5;
}
.packages-list-body .packages-list:nth-child(7) .packages-price-inset {
    border-color: #F647A7;
}
.tips-list {
    width: 100%;
    box-sizing: border-box;
    padding:10px;
    position: relative;
}
.tips::before {
    content: '※';
    position: absolute;
    left: 5px;
}
.tips {
    font-size: 12px;
    font-family: A-OTF Gothic MB101 Pro;
    font-weight: normal;
    color: #010101;
    line-height: 19px;
    width: 100%;
    box-sizing: border-box;
    padding-left: 20px;
    position: relative;
}
</style>